export const HIGH_RISK = 0.8;
export const MED_RISK  = 0.5;

export const RISK_COLORS = { high: "#dc2626", medium: "#d97706", low: "#057a55" };

export function riskColor(val) {
  if (val >= HIGH_RISK) return RISK_COLORS.high;
  if (val >= MED_RISK)  return RISK_COLORS.medium;
  return RISK_COLORS.low;
}

export function riskLabel(val) {
  if (val >= HIGH_RISK) return "High";
  if (val >= MED_RISK)  return "Medium";
  return "Low";
}

export function riskEmoji(val) {
  if (val >= HIGH_RISK) return "🔴";
  if (val >= MED_RISK)  return "🟡";
  return "🟢";
}

export function overallRisk(p) {
  return Math.max(p.malnutrition_risk || 0, p.anemia_risk || 0, p.growth_risk || 0);
}

export function aggregateByDistrict(predictions) {
  const acc = {};
  predictions.forEach(p => {
    const d = p.district;
    if (!d) return;
    if (!acc[d]) acc[d] = { malnutrition: 0, anemia: 0, growth: 0, count: 0 };
    acc[d].malnutrition += p.malnutrition_risk || 0;
    acc[d].anemia       += p.anemia_risk       || 0;
    acc[d].growth       += p.growth_risk       || 0;
    acc[d].count        += 1;
  });
  return Object.entries(acc).map(([name, v]) => ({
    name,
    count:        v.count,
    malnutrition: +((v.malnutrition / v.count) * 100).toFixed(1),
    anemia:       +((v.anemia       / v.count) * 100).toFixed(1),
    growth:       +((v.growth       / v.count) * 100).toFixed(1),
    avgRisk:      +((v.malnutrition + v.anemia + v.growth) / (v.count * 3)).toFixed(3),
  }));
}
